import * as React from 'react';
import { defaultTableWrapping, tableWrappingContext } from './context';
export var TableWrappingContextProvider = function (props) {
    var _a = props.wrapping, wrapping = _a === void 0 ? defaultTableWrapping : _a, children = props.children;
    return (React.createElement(tableWrappingContext.Provider, { value: wrapping }, children));
};
